import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Login';
import PromptsList from './components/PromptsList';
import PromptForm from './components/PromptForm';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/prompts"
            element={
              <ProtectedRoute>
                <PromptsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prompts/new"
            element={
              <ProtectedRoute>
                <PromptForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prompts/edit/:promptName"
            element={
              <ProtectedRoute>
                <PromptForm />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/prompts" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
